module.exports = __webpack_public_path__ + "static/media/Anfahrt1.5bffd495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Anfahrt1.jpg
// module id = 327
// module chunks = 0